export enum UrlHostWhiteList {
  LocalHost = 'localhost',
  FeatureBranchDomains = 'local.degreed.com',
  DegreedDevFeatureBranchRegEx = 'pr[0-9]+.degreed.dev',
}
